// Small shared brand mark for the portal auth pages (claim / login).
import { useTranslation } from "react-i18next";

export function ClientAuthBrand() {
  const { t } = useTranslation("clientPortal");
  return (
    <div className="inline-flex items-center gap-2.5">
      <span className="grid h-9 w-9 place-items-center rounded-md bg-grad-coral shadow-volt">
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden>
          <path
            d="M3 13h4l2-6 3 11 2.6-8L18 13h3"
            stroke="#fff"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="font-display text-lg font-extrabold tracking-tightest text-body">
        {t("app.name")}
      </span>
    </div>
  );
}
